import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getAllVendor() {
    const res = await fetch(API_ENDPOINT + "vendor/get-all/" + getToken());
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function payToVandor(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "vendor/payment", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200) {
        return await res.json();
    }
    throw await res.json();
}

export async function getVendorCashNote() {
    const res = await fetch(API_ENDPOINT + "transaction/cash-note/get-vendor/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
